import { BehaviorSubject } from 'rxjs';

const loadingSubject = new BehaviorSubject({});
let count = 0;
let numberOfRequests = 0;

export const loadingService = {
    observable: loadingSubject.asObservable(),
    set: set,
    setWithText: setWithText
}

function setWithText(show, text) {
    if (show) {
        numberOfRequests++;
        loadingSubject.next({
            show: show,
            text: text
        });
    }
    else {
        count++;
        if (count < numberOfRequests) {
            return;
        }

        // reset requests           
        count = 0;
        numberOfRequests = 0;

        loadingSubject.next({});
    }
}

function set(loading) {
    setWithText(loading, "Te rugam sa astepti..");
}